<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<form #f="ngForm">
  <div class="xrx-xmfax" [ngClass]="{ mfd: isMfd }">
    @if (!isMfd) {
      <label [xdaTranslate]="'SDE_RECIPIENT_FAX_NUMBER'"></label>
    }
    <div class="fax-number-outer-wrapper form-group">
      <div class="fax-number-wrapper">
        <div class="recipient-country-code" [ngClass]="{ 'd-flex': !isMfd }">
          <xrx-input-group
            type="{{ isMfd ? 'button' : 'number' }}"
            name="CountryCode"
            label="SDE_COUNTRY_CODE"
            classes="{{ isMfd ? 'textField medium' : '' }}"
            [isMfd]="isMfd"
            [maxlength]="maxlenCountryCode"
            id="countryCode"
            [(ngModel)]="cfg.countryCode"
            placeholder=""
            (change)="onChange($event)"
            (keyup)="onKeyUp($event, 'CountryCode')"
            (inputFocused)="onFocus($event)"
            (inputBlurred)="onBlur($event)"
            prependText="+"
            appendButton='{"type": "button", "class": "xrx-btn btn-secondary btn-short xgl-world_alt open-country-code", "tooltip": "SDE_COUNTRY_CODES", "tooltipTrigger": "hover"}'
            (appendButtonAction)="openCountryCodeModal()"
            class="w-100">
          </xrx-input-group>
        </div>
        <div class="recipient-fax-number">
          <xrx-input
            type="{{ isMfd ? 'button' : 'tel' }}"
            name="FaxNumber"
            label="SDE_NUMBER"
            classes="{{ isMfd ? 'textField medium' : '' }}"
            [isMfd]="isMfd"
            [maxlength]="maxlenFaxNumber"
            id="faxNumber"
            [(ngModel)]="cfg.faxNumber"
            placeholder=""
            (change)="onChange($event)"
            (keyup)="onKeyUp($event, 'FaxNumber')"
            (inputFocused)="onFocus($event)"
            (inputBlurred)="onBlur($event)"
            class="w-100">
          </xrx-input>
        </div>
      </div>
      @if (invalidCountryCode) {
        <span
          class="fax-number-error invalid-country-code invalid-feedback"
          [xdaTranslate]="invalidCountryCodeStr"></span>
      }
      @if (invalidFaxNumber) {
        <span
          class="fax-number-error invalid-fax-number invalid-feedback"
          [xdaTranslate]="invalidFaxNumberStr"></span>
      }
      @if (faxNumberComboInvalid) {
        <span
          class="fax-number-error invalid-combo invalid-feedback"
          [xdaTranslate]="invalidFaxNumberComboStr"></span>
      }
    </div>

    @if (!isMfd) {
      <div class="h-divider"></div>
    }

    <div
      class="cover-sheet form-group"
      [ngClass]="{
        'mb-0': !cfg.hasCoverPage,
        'mb-2 switch-on': cfg.hasCoverPage,
      }">
      <xrx-toggle-switch
        [label]="'SDE_COVER_SHEET'"
        [glyph]="isMfd ? '' : 'xgl-fax_cover_on'"
        [icon]="isMfd ? 'fax-cover-sheet' : ''"
        [isMfd]="isMfd"
        [switchOn]="cfg.hasCoverPage"
        (toggle)="cfg.hasCoverPage = !cfg.hasCoverPage; onChange($event)">
      </xrx-toggle-switch>
    </div>

    @if (cfg.hasCoverPage) {
      <div>
        <div class="language-select form-group mb-3-5">
          <!--{{cfg.language |json}}-->
          @if (!isMfd) {
            <xrx-select
              [label]="'SDE_LANGUAGE'"
              [list]="language"
              [localize]="'SDE_KEY'"
              [property]="'ISOCode'"
              [orderby]="'SDE_KEY'"
              [(selectedItem)]="_selectedLanguage"
              (change)="
                cfg.coverPageLanguage = $event.ISOCode;
                _selectedLanguage = $event;
                onChange($event)
              "
              [isInputOnly]="true">
            </xrx-select>
          }
          @if (isMfd) {
            <xrx-popover
              label="SDE_LANGUAGE"
              [showLabel]="true"
              [list]="language"
              [name]="'language'"
              [showIcon]="true"
              [sortOptions]="true"
              [key]="'SDE_KEY'"
              [property]="'ISOCode'"
              [orderByValue]="'languageName'"
              [(selectedValue)]="_selectedLanguage"
              (change)="
                cfg.coverPageLanguage = $event.ISOCode;
                _selectedLanguage = $event;
                onChange($event)
              ">
            </xrx-popover>
          }
        </div>
        @if (isMfd) {
          <label class="fax-label" [xdaTranslate]="'SDE_SUBJECT'"></label>
        }
        <div class="subject form-group mb-3-5">
          <xrx-input
            type="text"
            name="Subject"
            label="{{ isMfd ? '' : 'SDE_SUBJECT' }}"
            classes="{{ isMfd ? 'textField medium' : '' }}"
            [isMfd]="isMfd"
            [maxlength]="64"
            id="subject"
            [(ngModel)]="cfg.subject"
            placeholder="SDE_ENTER_FAX_SUBJECT"
            (change)="onChange($event)"
            (inputFocused)="onFocus($event)"
            (inputBlurred)="onBlur($event)"
            [error]="subjectRequired"
            class="w-100">
          </xrx-input>
        </div>
        @if (isMfd) {
          <label class="fax-label" [xdaTranslate]="'SDE_RECIPIENT'"></label>
        }
        <div class="recipient" [ngClass]="{ mfd: isMfd }">
          <div class="recipient-name form-group mb-3-5">
            <xrx-input
              type="text"
              name="Name"
              label="{{ isMfd ? '' : 'SDE_RECIPIENT_NAME' }}"
              classes="{{ isMfd ? 'textField medium' : '' }}"
              [isMfd]="isMfd"
              [maxlength]="64"
              id="name"
              [(ngModel)]="cfg.name"
              placeholder="SDE_ENTER_RECIPIENT_NAME"
              (change)="onChange($event)"
              (inputFocused)="onFocus($event)"
              (inputBlurred)="onBlur($event)"
              class="w-100">
            </xrx-input>
          </div>
          <div class="recipient-company form-group mb-3-5">
            <xrx-input
              type="text"
              name="Company"
              label="{{ isMfd ? '' : 'SDE_RECIPIENT_COMPANY' }}"
              classes="{{ isMfd ? 'textField medium' : '' }}"
              [isMfd]="isMfd"
              [maxlength]="70"
              id="company"
              [(ngModel)]="cfg.company"
              placeholder="SDE_ENTER_RECIPIENT_COMPANY"
              (change)="onChange($event)"
              (inputFocused)="onFocus($event)"
              (inputBlurred)="onBlur($event)"
              class="w-100">
            </xrx-input>
          </div>
        </div>
        @if (isMfd) {
          <label class="fax-label" [xdaTranslate]="'SDE_SENDER'"></label>
        }
        <div class="sender" [ngClass]="{ mfd: isMfd }">
          <div class="sender-name form-group mb-3-5">
            <xrx-input
              type="text"
              name="SenderName"
              label="{{ isMfd ? '' : 'SDE_SENDER_NAME' }}"
              classes="{{ isMfd ? 'textField medium' : '' }}"
              [isMfd]="isMfd"
              [maxlength]="64"
              id="senderName"
              [(ngModel)]="cfg.senderName"
              placeholder="SDE_ENTER_SENDER_NAME"
              (change)="onChange($event)"
              (inputFocused)="onFocus($event)"
              (inputBlurred)="onBlur($event)"
              class="w-100">
            </xrx-input>
          </div>
          <div class="sender-company form-group mb-3-5">
            <xrx-input
              type="text"
              name="SenderCompany"
              label="{{ isMfd ? '' : 'SDE_SENDER_COMPANY' }}"
              classes="{{ isMfd ? 'textField medium' : '' }}"
              [isMfd]="isMfd"
              [maxlength]="70"
              id="senderCompany"
              [(ngModel)]="cfg.senderCompany"
              placeholder="SDE_ENTER_SENDER_COMPANY"
              (change)="onChange($event)"
              (inputFocused)="onFocus($event)"
              (inputBlurred)="onBlur($event)"
              class="w-100">
            </xrx-input>
          </div>
        </div>
        <div class="comments form-group">
          <xrx-textarea
            type="text"
            name="Coments"
            label="{{ isMfd ? '' : 'SDE_COMMENTS' }}"
            classes="{{ isMfd ? 'textField medium' : '' }}"
            [isMfd]="isMfd"
            [rows]="3"
            [maxlength]="300"
            id="comments"
            [(ngModel)]="cfg.comments"
            placeholder="SDE_ENTER_COMMENT1"
            (change)="onChange($event)"
            (focus)="onFocus($event)"
            (blur)="onBlur($event)"
            class="w-100">
          </xrx-textarea>
        </div>
      </div>
    }
  </div>
</form>
